<template>
  <div class="col p-0 text-center">
    <ColorPointsHeader :message="greenHeaderMessage" color="rgba(190, 206, 35, 0.5)" />
    <div class="row center">
      <div class="col-md-1 col-lg-2"></div>
      <div class="col-12 col-md-10 col-lg-8">
        <div class="col-12 text-center p-2" v-html=" focus.paragraphe1 ? focus.paragraphe1.texte : '' "></div>
      </div>
      <div class="col-md-1 col-lg-2"></div>
    </div>
    <div class="bg-light-green d-flex flex-column align-items-center p-3">
      <img src="../../assets/images/assurancePrevoyance_p1_img1.png" class="img-fluid lozad"/>
      <div style="height: 0.3rem; width: 7rem" class="bg-primary mt-1"></div>
      <h2 class="font-weight-bold">En tant que professionnel ?</h2>
      <div class="row mt-5 text-left">
        <div class="col-md-1 col-lg-2"></div>
        <div class="col-4 col-md-3 col-lg-2 d-flex flex-column">
          <h5 class="text-secondary font-weight-bold" v-html=" focus.bulleA1 ? focus.bulleA1.titre : '' "></h5>
          <div style="height: 0.3rem; width: 7rem" class="bg-primary m-1"></div>
          <h5 class="text-secondary font-weight-bold" v-html=" focus.bulleB1 ? focus.bulleB1.titre : '' "></h5>
          <div style="height: 0.3rem; width: 7rem" class="bg-primary m-1"></div>
          <h5 class="text-secondary font-weight-bold" v-html=" focus.bulleC1 ? focus.bulleC1.titre : '' "></h5>
          <div style="height: 0.3rem; width: 7rem" class="bg-primary m-1"></div>
        </div>
        <div class="col-4 col-md-3 col-lg-3">
          <h6 class="font-weight-bold text-uppercase" v-html=" focus.paragraphe3 ? focus.paragraphe3.titre : '' "></h6>
          <div class="list-unstyled" v-html=" focus.paragraphe3 ? focus.paragraphe3.texte : '' "></div>
        </div>
        <div class="col-4 col-md-3 col-lg-3">
          <h6 class="font-weight-bold text-uppercase" v-html=" focus.paragraphe4 ? focus.paragraphe4.titre : '' "></h6>
          <div class="list-unstyled" v-html=" focus.paragraphe4 ? focus.paragraphe4.texte : '' "></div>
        </div>
        <div class="col-md-1 col-lg-2"></div>
      </div>
    </div>
    <div class="row center">
      <div class="col-lg-1"></div>
      <div class="d-none d-lg-flex col-2 justify-content-end">
        <img src="../../assets/images/effet-points-colonne-3.png"/>
      </div>
      <div class="paragraphe5 col-12 col-lg-6 d-flex align-items-center flex-column">
        <img src="../../assets/images/assurancePrevoyance_p2_img1.png" class="img-fluid lozad mt-5"/>
        <div style="height: 0.3rem; width: 7rem" class="bg-primary mt-2"></div>
        <h2 class="font-weight-bold" v-html=" focus.bulleB2 ? focus.bulleB2.titre : '' "></h2>
        <div class="list-unstyled text-uppercase font-weight-bold text-left mt-3" v-html=" focus.paragraphe5 ? focus.paragraphe5.texte : '' "></div>
      </div>
      <div class="d-none d-lg-flex col-lg-2 justify-content-start">
        <img src="../../assets/images/effet-points-colonne-4.png"/>
      </div>
      <div class="col-lg-1"></div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import { getFocus } from '../../mixins/getFocus'

export default {
  name: 'AssurancePrevoyance',
  mixins: [getFocus],
  components: {
    ColorPointsHeader: () => import('../../components/ColorPointsHeader')
  },
  data () {
    return {
      greenHeaderMessage: {
        titre: '',
        sousTitre: ''
      },
      temoignages: {},
      focus: []
    }
  },
  async beforeMount () {
    await this.getFocus('CG Courtage', 'Assurance / Prévoyance')
      .then(res => {
        this.focus = res
        this.greenHeaderMessage.titre = this.focus.cartouche ? this.focus.cartouche.titre : ''
        this.greenHeaderMessage.sousTitre = this.focus.cartouche ? this.focus.cartouche.texte : ''
      })
  }
}
</script>
<style>
.bg-light-green {
  background-color: #BECE234D;
}
.list-unstyled ul {
  list-style: none;
  padding-left: 0;
}
.paragraphe5 li {
  margin-top: 1.5rem;
}
</style>
